import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {ActionsRunJobsList} from './ActionsRunJobsList'

registerReactPartial('actions-run-jobs-list', {
  Component: ActionsRunJobsList,
})
